import {FieldConfig} from "./field-config";
import {RegistrationDisplayFlags} from "./registration-display-flags";
import {VisibilityTypes} from "./visibilty-types";

export class ApplicationFormSettings {
  raceId?: number;
  nameVisibility?: number;
  nameRegistrationDisplayFlag?: number;
  nameRequired?: boolean;
  lastnameVisibility?: number;
  lastnameRegistrationDisplayFlag?: number;
  lastnameRequired?: boolean;
  nicknameVisibility?: number;
  nicknameRegistrationDisplayFlag?: number;
  nicknameRequired?: boolean;
  genderVisibility?: number;
  genderRegistrationDisplayFlag?: number;
  genderRequired?: boolean;
  disciplineVisibility?: number;
  disciplineRegistrationDisplayFlag?: number;
  disciplineRequired?: boolean;
  disciplines?: number[];
  nationalityVisibility?: number;
  nationalityRegistrationDisplayFlag?: number;
  nationalityRequired?: boolean;
  birthdayRegistrationDisplayFlag?: number;
  birthdayRequired?: boolean;
  categoryRegistrationVisibility?: number;
  cityVisibility?: number;
  cityRegistrationDisplayFlag?: number;
  cityRequired?: boolean;
  addressVisibility?: number;
  addressRegistrationDisplayFlag?: number;
  addressRequired?: boolean;
  countryVisibility?: number;
  countryRegistrationDisplayFlag?: number;
  countryRequired?: boolean;
  identityCardNumberVisibility?: number;
  identityCardNumberRegistrationDisplayFlag?: number;
  identityCardNumberRequired?: boolean;
  identityCardExpiresVisibility?: number;
  identityCardExpiresRegistrationDisplayFlag?: number;
  identityCardExpiresRequired?: boolean;
  identityCardIssuerVisibility?: number;
  identityCardIssuerRegistrationDisplayFlag?: number;
  identityCardIssuerRequired?: boolean;
  clubVisibility?: number;
  clubRegistrationDisplayFlag?: number;
  clubRequired?: boolean;
  mobilePhoneVisibility?: number;
  mobilePhoneRegistrationDisplayFlag?: number;
  mobilePhoneRequired?: boolean;
  emailVisibility?: number;
  emailRegistrationDisplayFlag?: number;
  emailRequired?: boolean;
  emailVerification?: boolean;
  tshirtVisibility?: number;
  tshirtRegistrationDisplayFlag?: number;
  tshirtRequired?: boolean;
  tshirts?: number[];
  tshirtComment?: string;
  tshirtCommentEng?: string;
  tshirtCommentIta?: string;
  tshirtCommentSlo?: string;
  mealVisibility?: number;
  mealRegistrationDisplayFlag?: number;
  mealRequired?: boolean;
  meals?: number[];
  mealComment?: string;
  mealCommentEng?: string;
  mealCommentIta?: string;
  mealCommentSlo?: string;
  transportVisibility?: number;
  transportRegistrationDisplayFlag?: number;
  transportRequired?: boolean;
  transportComment?: string;
  transportCommentEng?: string;
  transportCommentIta?: string;
  transportCommentSlo?: string;
  commentVisibility?: number;
  commentRegistrationDisplayFlag?: number;
  comment?: string;
  commentEng?: string;
  commentIta?: string;
  commentSlo?: string;
  chipNumberVisibility?: number;
  chipNumberRegistrationDisplayFlag?: number;
  chipNumberRequired?: boolean;
  bestTimeVisibility?: number;
  bestTimeRegistrationDisplayFlag?: number;
  bestTimeRequired?: boolean;
  licenceVisibility?: number;
  licenceRegistrationDisplayFlag?: number;
  licenceRequired?: boolean;
  emergencyPhoneVisibility?: number;
  emergencyPhoneRegistrationDisplayFlag?: number;
  emergencyPhoneRequired?: boolean;
  feeVisibility?: number;
  customFields?: FieldConfig[];

  constructor() {
  }

  public static getApplicationFormSettingsDefault() {
    let settings = new ApplicationFormSettings();
    settings.raceId = undefined;
    settings.nameVisibility = VisibilityTypes.ALWAYS_VISIBLE;
    settings.nameRegistrationDisplayFlag = RegistrationDisplayFlags.ALWAYS_USED;
    settings.nameRequired = true;
    settings.lastnameVisibility = VisibilityTypes.ALWAYS_VISIBLE;
    settings.lastnameRegistrationDisplayFlag = RegistrationDisplayFlags.ALWAYS_USED;
    settings.lastnameRequired = true;
    settings.disciplineRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.disciplineVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.disciplineRequired = false;
    settings.disciplines = undefined;
    settings.birthdayRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.birthdayRequired = false;
    settings.nationalityVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.nationalityRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.nationalityRequired = false;
    settings.nicknameVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.nicknameRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.nicknameRequired = false;
    settings.categoryRegistrationVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.cityVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.cityRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.cityRequired = false;
    settings.addressVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.addressRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.addressRequired = false;
    settings.countryVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.countryRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.countryRequired = false;
    settings.identityCardNumberVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.identityCardNumberRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.identityCardNumberRequired = false;
    settings.identityCardExpiresVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.identityCardExpiresRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.identityCardExpiresRequired = false;
    settings.identityCardIssuerVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.identityCardIssuerRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.identityCardIssuerRequired = false;
    settings.clubVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.clubRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.clubRequired = false;
    settings.mobilePhoneVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.mobilePhoneRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.mobilePhoneRequired = false;
    settings.emailVisibility = VisibilityTypes.ALWAYS_VISIBLE;
    settings.emailRegistrationDisplayFlag = RegistrationDisplayFlags.ALWAYS_USED;
    settings.emailRequired = true;
    settings.tshirtVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.tshirtRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.tshirtRequired = false;
    settings.tshirts = undefined;
    settings.tshirtComment = ""
    settings.mealVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.mealRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.mealRequired = false;
    settings.meals = undefined;
    settings.mealComment = "";
    settings.transportVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.transportRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.transportRequired = false;
    settings.transportComment = undefined;
    settings.commentVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.commentRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.comment = undefined;
    settings.chipNumberVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.chipNumberRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.chipNumberRequired = false;
    settings.bestTimeVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.bestTimeRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.bestTimeRequired = false;
    settings.licenceVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.licenceRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.licenceRequired = false;
    settings.emergencyPhoneVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.emergencyPhoneRegistrationDisplayFlag = RegistrationDisplayFlags.NOT_USED;
    settings.emergencyPhoneRequired = false;
    settings.feeVisibility = VisibilityTypes.NOT_VISIBLE;
    settings.customFields = undefined;
    return settings;
  }
}
